import { BuilderConfig } from '@/types/builder';

import RoomStayBlogCustomerImageText, { CustomerCaseImageTextProps } from './roomstay-blog-customer-case-image-text';

export const RoomStayBlogCustomerImageTextBuilderConfig = {
    name: 'Customer Case Image Text',
    inputs: [
        {
            name: 'image',
            type: 'file',
        },
        {
            name: 'tag',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'title',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'subDescription',
            type: 'richText',
            defaultValue: '',
        }
    ],
};

const builderConfig: BuilderConfig<CustomerCaseImageTextProps> = {
    component: RoomStayBlogCustomerImageText,
    config: RoomStayBlogCustomerImageTextBuilderConfig,
};

export default builderConfig;
